import React from 'react';
import './footer.css';

const Footre = () => {
  return (
    <footer>
      <div className='footer__container'>
        <p>©2024 All rights reserved to Neelapu Venkata Naidu</p>
      </div>
    </footer>
  )
}

export default Footre;
